export default __webpack_public_path__ + "static/media/under.e115eb89.svg";